import { TableContainer } from '@material-ui/core'
import styled from 'styled-components'

export const tabelaArrastavelStyles = {
  TableContainer: styled(TableContainer)`
    max-height: 40vh;
    width: auto;
  `
}
